import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { Warning } from '@phosphor-icons/react/dist/ssr';

interface ErrorTextProps {
  children: string;
}

const ErrorText = ({ children }: ErrorTextProps) => (
  <div className="flex" data-testid="error-text">
    <PhosphorIcon
      Icon={Warning}
      variant="fill"
      className="icon-s mr-xxs ml-0 shrink-0 text-error"
    />
    <span className="font-bold text-small">{children}</span>
  </div>
);

export default ErrorText;
